import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import type { ReactNode } from 'react';
import { fonts } from '@/shared/theme';
import { Icon, type IconName } from './icon';
import { Panel } from './surfaces';

interface DisclosureCardProps {
  open: boolean;
  onToggle: () => void;
  title: ReactNode;
  hint?: ReactNode;
  /** Right-aligned note before the chevron (hidden on phones). */
  aside?: ReactNode;
  icon?: IconName;
  controls?: string;
}

/** Full-width toggle card that opens a section below ("Alle Kennzahlen je Standort"). */
export function DisclosureCard({
  open,
  onToggle,
  title,
  hint,
  aside,
  icon = 'table',
  controls,
}: DisclosureCardProps) {
  return (
    <Panel
      component={ButtonBase}
      onClick={onToggle}
      aria-expanded={open}
      aria-controls={controls}
      sx={(theme) => ({
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '14px',
        p: '15px 18px',
        mb: '14px',
        textAlign: 'left',
        '&:hover': { background: theme.vars.palette.md.panel2 },
      })}
    >
      <Box
        sx={(theme) => ({ display: 'flex', flex: 'none', color: theme.vars.palette.md.primary })}
      >
        <Icon name={icon} />
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Box sx={{ fontFamily: fonts.head, fontWeight: 700, fontSize: 15.5 }}>{title}</Box>
        {hint && <Box sx={{ fontSize: 12, color: 'text.secondary', mt: '3px' }}>{hint}</Box>}
      </Box>
      {aside && (
        <Box
          sx={{
            flex: 'none',
            fontSize: 12,
            color: 'text.secondary',
            whiteSpace: 'nowrap',
            display: { xs: 'none', sm: 'block' },
          }}
        >
          {aside}
        </Box>
      )}
      <Box
        sx={{
          display: 'flex',
          flex: 'none',
          color: 'text.secondary',
          transform: open ? 'rotate(180deg)' : 'none',
          transition: 'transform .2s',
        }}
      >
        <Icon name="chevronDown" />
      </Box>
    </Panel>
  );
}
